// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

ion-toolbar {
  padding-right: 1rem;
}

ion-icon {
  font-size: var(--font-size-xl);
}

ion-item:not([color=danger]) {
  --background: var(--color-surface);
  --color: var(--color-text-secondary);
  --border-color: var(--color-border);
  --detail-icon-color: var(--color-primary);
  --detail-icon-opacity: 1;
}
ion-item:not([color=danger]) ion-icon {
  color: var(--color-primary);
}
ion-item:not([color=danger]) ion-label {
  font-size: var(--font-size-medium);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
}

.language-buttons {
  display: flex;
  align-items: flex-end;
  margin-left: 0;
}
.language-buttons ion-button {
  --padding-start: 4px;
  --padding-end: 4px;
  --padding-top: 4px;
  --padding-bottom: 4px;
  height: 30px;
  margin: 0 2px;
}
.language-buttons ion-button.active {
  --background: var(--color-primary-pale, rgba(0, 153, 188, 0.15));
  border-radius: var(--radius-sm, 4px);
}
.language-buttons .flag-icon {
  border: 1px solid var(--color-border);
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 599px) {
  ion-item {
    --min-height: 40px;
  }
  ion-item[color=danger] ion-label {
    font-size: var(--font-size-medium);
  }
  .flag-icon {
    width: 20px;
    height: 14px;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  ion-item {
    --min-height: 48px;
  }
  .flag-icon {
    width: 22px;
    height: 16px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  ion-item {
    --min-height: 56px;
  }
  .flag-icon {
    width: 24px;
    height: 18px;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/components/navigation-bar/navigation-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,kCAAA;EACA,oCAAA;EACA,mCAAA;EACA,yCAAA;EACA,wBAAA;AACF;AACE;EACE,2BAAA;AACJ;AAEE;EACE,kCAAA;EACA,sCAAA;EACA,kCAAA;AAAJ;;AAIA;EACE,aAAA;EACA,qBAAA;EACA,cAAA;AADF;AAGE;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;AADJ;AAGI;EACE,gEAAA;EACA,oCAAA;AADN;AAKE;EACE,qCAAA;AAHJ;;AAQA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AACA;EACE;IACE,kBAAA;EAPJ;EAUE;IACE,kCAAA;EARJ;EAWE;IACE,WAAA;IACA,YAAA;EATJ;AACF;AAYA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;IACE,kBAAA;EAZJ;EAeE;IACE,WAAA;IACA,YAAA;EAbJ;AACF;AAgBA,4BAAA;AAEA,yBAAA;AAEC,8DAAA;AACC;EACE;IACE,kBAAA;EAhBJ;EAmBE;IACE,WAAA;IACA,YAAA;EAjBJ;AACF;AAoBA,4BAAA","sourcesContent":[":host {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\nion-toolbar {\r\n  padding-right: 1rem;\r\n}\r\n\r\nion-icon {\r\n  font-size: var(--font-size-xl);\r\n}\r\n\r\nion-item:not([color=\"danger\"]) {\r\n  --background:        var(--color-surface);\r\n  --color:             var(--color-text-secondary);\r\n  --border-color:      var(--color-border);\r\n  --detail-icon-color: var(--color-primary);\r\n  --detail-icon-opacity: 1;\r\n\r\n  ion-icon {\r\n    color: var(--color-primary);\r\n  }\r\n\r\n  ion-label {\r\n    font-size:   var(--font-size-medium);\r\n    font-weight: var(--font-weight-medium);\r\n    color:       var(--color-text-secondary);\r\n  }\r\n}\r\n\r\n.language-buttons {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  margin-left: 0;\r\n\r\n  ion-button {\r\n    --padding-start: 4px;\r\n    --padding-end: 4px;\r\n    --padding-top: 4px;\r\n    --padding-bottom: 4px;\r\n    height: 30px;\r\n    margin: 0 2px;\r\n\r\n    &.active {\r\n      --background: var(--color-primary-pale, rgba(0, 153, 188, 0.15));\r\n      border-radius: var(--radius-sm, 4px);\r\n    }\r\n  }\r\n\r\n  .flag-icon {\r\n    border: 1px solid var(--color-border);\r\n  }\r\n}\r\n\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 599px) {\r\n    ion-item {\r\n      --min-height: 40px;\r\n    }\r\n\r\n    ion-item[color=\"danger\"] ion-label {\r\n      font-size: var(--font-size-medium);\r\n    }\r\n\r\n    .flag-icon {\r\n      width: 20px;\r\n      height: 14px;\r\n    }\r\n  }\r\n\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    ion-item {\r\n      --min-height: 48px;\r\n    }\r\n\r\n    .flag-icon {\r\n      width: 22px;\r\n      height: 16px;\r\n    }\r\n  }\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1024px) {\r\n    ion-item {\r\n      --min-height: 56px;\r\n    }\r\n\r\n    .flag-icon {\r\n      width: 24px;\r\n      height: 18px;\r\n    }\r\n  }\r\n\r\n/*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
